import { ReactComponent as NARRATIVE_TEXT } from 'assets/icons/NARRATIVE_TEXT.svg';
import { ReactComponent as LETTER_NAMING } from 'assets/icons/LETTER_NAMING.svg';
import { ReactComponent as INFORMATIONAL_TEXT } from 'assets/icons/INFORMATIONAL_TEXT.svg';
import { ReactComponent as LETTER_VOWEL_CLUSTERS } from 'assets/icons/LETTER_VOWEL_CLUSTERS.svg';

const categories = {
    BIBLICAL_TEXT: "BIBLICAL_TEXT",
    REAL_WORDS: "REAL_WORDS",
    NARRATIVE_TEXT: "NARRATIVE_TEXT",
    INFORMATIONAL_TEXT: "INFORMATIONAL_TEXT",
    LETTER_VOWEL_CLUSTERS: "LETTER_VOWEL_CLUSTERS",
    LETTER_NAMING: "LETTER_NAMING",
    LETTER_SOUNDS: "LETTER_SOUNDS",
    VOWEL_SOUND: "VOWEL_SOUND"
}

const categoriesWithIcons = {
    [categories.INFORMATIONAL_TEXT]: {
        icon: INFORMATIONAL_TEXT
    },
    [categories.LETTER_NAMING]: {
        icon: LETTER_NAMING
    },
    [categories.NARRATIVE_TEXT]: {
        icon: NARRATIVE_TEXT
    },
    [categories.INFORMATIONAL_TEXT]: {
        icon: INFORMATIONAL_TEXT
    },
    [categories.LETTER_VOWEL_CLUSTERS]: {
        icon: LETTER_VOWEL_CLUSTERS
    },
    ["default"]: {
        icon: INFORMATIONAL_TEXT
    }
}

export { categoriesWithIcons }
export default categories